import { Shift } from '@bofrak-backend/shared';
import { atom } from 'recoil';

const globalCurrentShiftAtom = atom<Shift | null>({
  key: 'globalCurrentShiftAtom',
  default: null,
});

export { globalCurrentShiftAtom };
